module.exports = __webpack_public_path__ + "77FXFjRbGzN4aCrSFhlh3hJtnKITppOI_IvcXXDNrsc.88f58f065e68822986c7.woff2";


//////////////////
// WEBPACK FOOTER
// D:/OficinaVirtual/FrontEndFinamco/EFactoringManager/src/assets/fonts/roboto/77FXFjRbGzN4aCrSFhlh3hJtnKITppOI_IvcXXDNrsc.woff2
// module id = ../../../../../src/assets/fonts/roboto/77FXFjRbGzN4aCrSFhlh3hJtnKITppOI_IvcXXDNrsc.woff2
// module chunks = styles